/**
 * The requests module's routes, owned by the feature.
 *
 * D5 says a feature exports its own routes and `app/router.tsx` composes them. **Both halves are
 * true since T71 closed F-069**: this array is the feature's, and `src/app/router.tsx` spreads it.
 *
 * The array shape is what made that swap cost nothing when it happened.
 */
import { lazy } from 'react';
import type { RouteObject } from 'react-router-dom';

const RequestsPage = lazy(() => import('./RequestsPage'));

export const requestsRoutes: RouteObject[] = [{ path: 'requests', element: <RequestsPage /> }];
